import { mapGetters } from "vuex";
import { flattenDeep } from "lodash";

export default {
  mounted() {
    this.$nextTick(() => {
      const $target = this.$el.querySelector("select");

      const config = {
        create: this.create_other ? value => ({ value, text: value }) : false,
        multiple: Object.hasOwnProperty("multiple") ? this.multiple : false,
      };

      if (this.limit) {
        config.maxItems = this.limit;
      }

      const items = this.initiallySelectedItems();

      $($target).selectize({ ...config }); // eslint-disable-line

      this.$selectize = $target.selectize;

      // ensure custom options are still present in the list
      this.$selectize.addOption(items.map(i => ({ value: i, text: i })));

      items.forEach(item => this.$selectize.addItem(item));

      this.$selectize.on("change", this.updateSelection.bind(this));
    });
  },

  beforeDestroy() {
    this.$selectize.destroy();
  },

  computed: {
    ...mapGetters(["getRegistrationValue"]),
  },

  methods: {
    updateSelection() {
      throw new Error("No [updateSelection()] method has been defined on this component yet!");
    },

    // Provides point to override the attribute to be looked up in the store
    selectizeAttribute() {
      return this.attribute;
    },

    initiallySelectedItems() {
      return flattenDeep([this.getRegistrationValue(this.selectizeAttribute())])
        .map(item => String(item || "").trim())
        .filter(item => item.length);
    },
  },
};
